import React from "react";
import ReactTooltip from 'react-tooltip';
import { t } from "../../utils/i18n";

const TableBody = ({ policies }) => (
  <tbody>
    {policies.map((policy, i) => (
      <tr key={i}
        className={
          (policy.policy_year == 11 || policy.age == 65 || policy.age == 90) ? "year-" + policy.policy_year + " age-" + policy.age : ''}
          >
        <td>
          <div>
            <span>{policy.policy_year}</span>
            <span>{(policy.policy_year == 11 || policy.age == 65 || policy.age == 90) && (
              <span>
                <a data-toggle="collapse" href={"#help" + policy.age} role="button" aria-expanded="false" aria-controls={"help" + policy.age}>
                  <sup><i className="fa fa-question-circle"></i></sup>
                </a>
                <span className="collapse multi-collapse show" id={"help" + policy.age}><br></br><small>
                  {
                    (policy.policy_year == 11 && " " + t("referrals.insurance_calc.tb_year11")) ||
                    (policy.age == 65 && " " + t("referrals.insurance_calc.tb_age65")) ||
                    (policy.age == 90 && " " + t("referrals.insurance_calc.tb_age90"))
                  }
                  </small>
                </span>
              </span>
            )}
            </span>
          </div>
        </td>
        <td>{policy.age}</td>
        <td>{policy.planned_premium}</td>
        <td>{policy.annual_income}</td>
        <td>{policy.accumulated_value}</td>
        <td>{policy.surrender_value}</td>
        <td>{policy.net_death_benefit}</td>
      </tr>
    ))}
  </tbody>
);

export default TableBody;
